import { StyleRules } from '@material-ui/core/styles';
import { AccordionSummaryClassKey } from '@material-ui/core/AccordionSummary';

import { core as theme } from '../styles/core';

export const MuiAccordionSummary: Partial<StyleRules<
  AccordionSummaryClassKey
>> = {
  content: {
    margin: '2rem 0',
    '&$expanded': {
      margin: '2rem 0',
    },
  },
  expandIcon: {
    color: theme.palette.grey[600],
  },
  root: {
    padding: '0 2rem',
  },
};
